<template lang="pug">
  .panel-page
    .panel.mx-auto.body-1
      FormErrorAlert(heading="Error"
                      :message="message"
                      v-show="message"
                      @dismiss="message = ''")
      h1 Edit Profile
      form(autocomplete="off")
        AccountSection.mt-4(message="MY PROFILE" required)
          EditPersonalInfo(
            :username.sync="username"
            :firstName.sync="firstName"
            :middleName.sync="middleName"
            :lastName.sync="lastName"
            :title.sync="title"
            :email.sync="email"
            :altEmail1.sync="altEmail1"
            :altEmail2.sync="altEmail2"
            :workPhone.sync="workPhone"
            :superFirstName.sync="superFirstName"
            :superMiddleName.sync="superMiddleName"
            :superLastName.sync="superLastName"
            :superRank.sync="superRank"
            :superEmail.sync="superEmail"
            :superPhone.sync='superPhone'
            :firstNameInvalid="firstNameInvalid"
            :lastNameInvalid="lastNameInvalid"
            :altEmail1Invalid="altEmail1IfInvalid"
            :altEmail2Invalid="altEmail2IfInvalid"
            :phoneFormatInvalid="phoneFormatInvalid"
            :superFirstNameInvalid="superFirstNameInvalid"
            :superLastNameInvalid="superLastNameInvalid"
            :superRankInvalid="superRankInvalid"
            :superEmailInvalid="superEmailInvalid"
            :superEmailIfInvalid="superEmailIfInvalid"
            :superPhoneFormatInvalid="superPhoneFormatInvalid"
            :superPhoneInvalid="superPhoneInvalid"
            :show-notes="false"
            @save="save"
            @cancel="$router.push({name: 'my_account'})"
          )
</template>

<script>
import {
  mapTouched,
  mapRequired,
  mapRequiredIf,
  validationHelpers,
  phoneNumberValidators,
} from '@/lib/validation'
import { updateProfile } from '@/lib/services/account'
import AccountSection from '@/components/AccountSection'
import EditPersonalInfo from '@/components/EditPersonalInfo'
import stdmsg from '@/lib/stdmsg'
import store from '@/store'
import { globalSuccess } from '@/lib/utils'
import { globalError } from '../lib/utils'

export default {
  name: 'EditProfile',
  data() {
    return {
      message: '',
      username: store.state.account.username,
      firstName: store.state.account.firstName,
      lastName: store.state.account.lastName,
      middleName: store.state.account.middleName,
      title: store.state.account.title,
      email: store.state.account.email,
      altEmail1: store.state.account.altEmail1,
      altEmail2: store.state.account.altEmail2,
      workPhone: store.state.account.workPhone,
      superFirstName: store.state.account.supervisorFirstName,
      superMiddleName: store.state.account.supervisorMiddleName,
      superLastName: store.state.account.supervisorLastName,
      superRank: store.state.account.supervisorRank,
      superEmail: store.state.account.supervisorEmail,
      superPhone: store.state.account.supervisorPhone,
      ...mapTouched([
        'lastName',
        'firstName',
        'altEmail1',
        'altEmail2',
        'workPhone',
        'superFirstName',
        'superLastName',
        'superRank',
        'superEmail',
        'superPhone'
      ]),
    }
  },
  components: {
    AccountSection,
    EditPersonalInfo,
  },
  methods: {
    ...validationHelpers(),
    save() {
      this.markAllTouched()
      const anyInvalid =
        this.firstNameInvalid ||
        this.lastNameInvalid ||
        this.altEmail1IfInvalid ||
        this.altEmail2IfInvalid ||
        this.phoneFormatInvalid ||
        this.superFirstNameInvalid ||
        this.superLastNameInvalid ||
        this.superRankInvalid ||
        this.superEmailInvalid ||
        this.superEmailIfInvalid ||
        this.superPhoneFormatInvalid ||
        this.superPhoneInvalid
      if (anyInvalid) {
        this.message = stdmsg.formError
        scrollTo(0, 0)
        return
      }

      updateProfile({
        username: this.username,
        firstName: this.firstName,
        lastName: this.lastName,
        middleName: this.middleName,
        title: this.title,
        altEmail1: this.altEmail1,
        altEmail2: this.altEmail2,
        workPhone: this.formattedPhoneNumber,
        supervisorFirstName: this.superFirstName,
        supervisorLastName: this.superLastName,
        supervisorMiddleName: this.superMiddleName,
        supervisorRank: this.superRank,
        supervisorEmail: this.superEmail,
        supervisorPhone: this.formattedSuperPhoneNumber,
      })
        .then(() => {
          this.$router.push({ name: 'my_account' })
          globalSuccess(null, 'The user profile was updated successfully.')
          scrollTo(0, 0)
          store.dispatch('account/retrieveInfo')
        })
        .catch(err => {
          globalError(err)
        })
    },
    cancel() {
      this.$router.push({ name: 'my_account' })
    },
  },
  computed: {
    ...mapRequired(['lastName', 'firstName', 'superLastName', 'superFirstName', 'superRank', 'superEmail', 'superPhone']),
    ...mapRequiredIf(['altEmail1', 'altEmail2', 'superEmail'], x => /[^@]+@.+\..+/.test(x)),
    ...phoneNumberValidators('workPhone'),
    ...phoneNumberValidators('superPhone', 'superPhoneFormatInvalid'),
    formattedPhoneNumber() {
      return this.workPhone.replace(/[^\d]/g, '')
    },
    formattedSuperPhoneNumber() {
      return this.superPhone.replace(/[^\d]/g, '')
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
